import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import store from '@/store/index.js'
import Layout from "@/layout/Layout.vue";

export const constantRoutes = [
	// 业务页面
	// 默认
	{
		path: "/",
		redirect: "/index"
	},
	// 首页
	{
		path: "/index",
		name: "home",
		component: () => import("@/views/home/index"),
	},
	// 资讯
	{
		path: "/information/index",
		name: "information",
		component: () => import("@/views/information/index"),
	},
	// 资讯详情
	{
		path: "/information/details",
		name: "informationDetails",
		component: () => import("@/views/information/details"),
		props: (route) => ({
			id: route.query.id,
			type: route.query.type,
			from: route.query.from,
		}),
	},
	// 技术文件
	{
		path: "/technology/index",
		name: "technology",
		component: () => import("@/views/technology/index"),
	},
	// 碳核算
	{
		path: "/check/index",
		name: "check",
		component: () => import("@/views/check/index"),
	},
	// 碳认证
	{
		path: "/authentication/index",
		name: "authentication",
		component: () => import("@/views/authentication/index"),
	},
	// 碳标签
	{
		path: "/tag/index",
		name: "tag",
		component: () => import("@/views/tag/index"),
	},
	// 绿色评价
	{
		path: "/evaluate/index",
		name: "evaluate",
		component: () => import("@/views/evaluate/index"),
	},
	// 关于我们
	{
		path: "/about/index",
		name: "about",
		component: () => import("@/views/about/index"),
	},
	// 一站式的管理服务
	{
		path: "/yzsdglfw/index",
		name: "yzsdglfw",
		component: () => import("@/views/yzsdglfw/index"),
	},
	// 产业链上下游全覆盖
	{
		path: "/cylsxyqfg/index",
		name: "cylsxyqfg",
		component: () => import("@/views/cylsxyqfg/index"),
	},
	// 科学专业的核算支撑
	{
		path: "/kxzydhszc/index",
		name: "kxzydhszc",
		component: () => import("@/views/kxzydhszc/index"),
	},
	// 面向国际互认和行业采信
	{
		path: "/mxgjhrhhycx/index",
		name: "mxgjhrhhycx",
		component: () => import("@/views/mxgjhrhhycx/index"),
	},
	// 意见反馈
	{
		path: "/feedback/index",
		name: "feedback",
		component: () => import("@/views/feedback/index"),
	},
	// 品牌(测试)
	{
		path: "/brand/index",
		name: "brand",
		component: () => import("@/views/brand/index"),
	},
	// 登录页
	{
		path: "/login",
		name: "login",
		component: () => import("@/views/login/index"),
	},
	// 忘记密码
	{
		path: "/forget",
		name: "forget",
		component: () => import("@/views/forget/index"),
	},
	// 注册页
	{
		path: "/register",
		name: "register",
		component: () => import("@/views/register/index"),
	},
	// 注册申请
	{
		path: "/registerApply",
		name: "registerApply",
		component: () => import("@/views/register/apply"),
	},
	// 注册申请信息
	{
		path: "/applyInfo",
		name: "applyInfo",
		component: () => import("@/views/register/info"),
		meta: {
			requiresAuth: true
		}
	},
	// 注册申请失败
	{
		path: "/applyFail",
		name: "applyFail",
		component: () => import("@/views/register/fail"),
		meta: {
			requiresAuth: true
		}
	},
	// 未匹配页面
	{
		path: '/404',
		name: 'not-found',
		component: () => import('@/views/error/404'),
	},
	// 
	{
		path: '/401',
		component: () => import('@/views/error/401'),
	},
	// 后备路由，当未匹配到路由时重定向到404
	{
		path: '*',
		redirect: "/404",
	},
	// {
	// 	path: "/register",
	// 	component: Layout,
	// 	children: [
			
	// 	],
	// },
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [];

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
	mode: "hash",
	base: process.env.VUE_APP_BASE_URL || "",
	// mode: 'history', // 去掉url中的#
	// scrollBehavior: () => ({y: 0}),
	routes: constantRoutes,
	scrollBehavior(to, from, saveTop) {
		console.log(1.1,to, from, saveTop);
		saveTop = saveTop || to.meta.saveTop
		if (to.path == '/information/details') {
			console.log('强制顶部');
			return {
				x: 0,
				y: 0,
			};
		} else {
			if (saveTop) {
				console.log(2.1, saveTop);
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						resolve(saveTop);
					}, 0);
				});
			} else if (to.hash) {
				console.log(2.2, to.hash);
				return {
					selector: to.hash,
				};
			} else if (to.meta.scrollTop) {
				console.log(2.3, to.meta.scrollTop);
				return {
					x: 0,
					y: to.meta.scrollTop
				}
			} else {
				console.log(2.4);
				return {
					x: 0,
					y: 0,
				};
			}
		}
		
	},
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
	{
		// 首页处理
		if (from.path == '/index'){
			if (to.path == '/check/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/authentication/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/tag/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/evaluate/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/about/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/technology/index') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/information/index') {
				store.dispatch('delView', 'information').then(() => {
					store.dispatch('addView', 'information')
				})
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else if (to.path == '/information/details') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else {
				from.meta.scrollTop = ''
			}
		}
		// 资讯列表处理
		if (from.path == '/information/index'){
			if (to.path == '/information/details') {
				from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			} else {
				from.meta.scrollTop = ''
			}
		}
		// 资讯详情处理
		if (from.path == '/information/details'){
			if (to.path == '/information/index') {
				store.dispatch('addView', 'information')
			} else {
				
			}
		}
	}
	
	// 页面登录拦截
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!store.state.token) {
			next({
				name: 'login',
				query: {
					redirect: to.fullPath
				}
			})
		} else {
			next()
		}
	} else {
		next() // 确保一定要调用 next()
	}

});

// 全局后置钩子
router.afterEach((to, from, next) => {});

export default router;